import { useEffect, useState } from "react";
import ZipperOverlay from "./ZipperOverlay";

/* A branded zip-open intro shown once per session on first load. */
export default function DenimIntro() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (
            sessionStorage.getItem("urwan_intro_seen") ||
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
            return;
        }
        sessionStorage.setItem("urwan_intro_seen", "1");
        setShow(true);
        document.body.style.overflow = "hidden";
    }, []);

    const done = () => {
        setShow(false);
        document.body.style.overflow = "";
    };

    return <ZipperOverlay show={show} onDone={done} intro />;
}
